import React from 'react';
import { Plus, Trash2, GripVertical } from 'lucide-react';
import { Card, Field, TextField, SaveButton, useSection } from '../AdminUI';

function ListEditor({ items, setItems, fields }) {
  const update = (idx, key, val) => setItems(items.map((it, i) => i === idx ? { ...it, [key]: val } : it));
  const remove = (idx) => setItems(items.filter((_, i) => i !== idx));
  const add = () => setItems([...items, fields.reduce((o, f) => ({ ...o, [f.key]: '' }), { id: `new_${Date.now()}` })]);
  const move = (idx, dir) => {
    const ni = idx + dir;
    if (ni < 0 || ni >= items.length) return;
    const arr = [...items]; const t = arr[idx]; arr[idx] = arr[ni]; arr[ni] = t;
    setItems(arr);
  };
  return (
    <div className="space-y-2">
      {items.map((it, i) => (
        <div key={it.id || i} className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-3 flex flex-col md:flex-row md:items-end gap-2">
          <div className="flex md:flex-col items-center gap-1 text-zinc-500">
            <button onClick={() => move(i, -1)} className="text-xs hover:text-zinc-200">▲</button>
            <GripVertical size={14} />
            <button onClick={() => move(i, 1)} className="text-xs hover:text-zinc-200">▼</button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 flex-1">
            {fields.map((f) => (
              <Field key={f.key} label={f.label}>
                <TextField value={it[f.key] ?? ''} onChange={(v) => update(i, f.key, v)} placeholder={f.placeholder} />
              </Field>
            ))}
          </div>
          <button onClick={() => remove(i)} className="shrink-0 h-9 px-3 rounded-md bg-red-600/15 hover:bg-red-600/25 text-red-300 border border-red-900/40 flex items-center gap-1 text-xs">
            <Trash2 size={14} /> Remove
          </button>
        </div>
      ))}
      <button onClick={add} className="w-full h-10 rounded-md border border-dashed border-zinc-700 hover:border-[color:var(--gold)]/50 hover:bg-zinc-900/60 text-zinc-300 text-sm font-semibold flex items-center justify-center gap-1.5">
        <Plus size={14} /> Add Item
      </button>
    </div>
  );
}

export default function NavigationSection() {
  const [local, setLocal, save] = useSection('navigation');
  return (
    <Card title="Top Navigation" desc="Add, edit or reorder the horizontal nav items." footer={<SaveButton onClick={save} />}>
      <ListEditor items={local} setItems={setLocal} fields={[
        { key: 'label', label: 'Label' },
        { key: 'icon', label: 'Icon (lucide name)', placeholder: 'CircleDot' },
        { key: 'link', label: 'Link' }
      ]} />
      <p className="text-[11px] text-zinc-500 mt-3">Tip: Use any icon name from <a className="text-[color:var(--gold)] underline" href="https://lucide.dev/icons" target="_blank" rel="noreferrer">lucide.dev</a> e.g. CircleDot, Trophy, Spade, Dog.</p>
    </Card>
  );
}

export { ListEditor };
